import script from "./PageOrganizationHouseTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./PageOrganizationHouseTemplate.vue?vue&type=script&setup=true&lang=js"

import "./PageOrganizationHouseTemplate.vue?vue&type=style&index=0&id=195ce6de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-195ce6de"]])

export default __exports__